<template>
  <div class="flex flex-1 flex-col items-center justify-center gap-2">
    <UIcon name="light:inbox" class="size-10 text-gray-300" />
    <div class="font-semibold">
      You're All Caught Up! 🎉
    </div>
    <div>It looks like there’s nothing here… yet.</div>
  </div>
</template>
